import DataQuery from 'library/util/query';
import { jsonToInputParams } from 'library/util/graph';
import { resolve } from 'library/helpers/path-resolver';
import { NotificationRender } from 'library/components/notification';

export const archiveRecommendationFromUser = async (recommendationId) => {
  return await DataQuery(
    `mutation {
        archive_recommendation_from_user(
          ${jsonToInputParams({ recommendation_id: recommendationId })}
        ) {
          errors
          success
        }
      }`
  );
};

export const parseArchiveRecommendationQueryResult = (data) => ({
  errors: resolve(data, 'archive_recommendation_from_user/errors', []),
  success: resolve(data, 'archive_recommendation_from_user/success', false),
});

export const rejectRecommendationAction = async (
  outcome,
  configuration,
  reloadOutcomes
) => {
  try {
    const { data } = await archiveRecommendationFromUser(
      outcome.recommendationId
    );
    const { success, errors } = parseArchiveRecommendationQueryResult(data);
    const message = success
      ? `The recommendation for the ${resolve(
          configuration,
          'environment/journey/goals_name',
          'outcome'
        )} has been removed.`
      : `There was an error rejecting your recommended ${resolve(
          configuration,
          'environment/journey/goals_name',
          'outcome'
        )}`;
    const notificationType = success ? 'success' : 'error';
    NotificationRender(notificationType, message);
    reloadOutcomes();
    if (resolve(errors, 'length', 0) > 0) console.error(errors);
  } catch (e) {
    console.error(e);
    NotificationRender(
      'error',
      `There was an error rejecting your recommended ${resolve(
        configuration,
        'environment/journey/goals_name',
        'outcome'
      )}`
    );
  }
};
